import { Route, Routes } from 'react-router-dom';
import { CouponsPage } from './CouponsPage';
import { ModifyCouponPage } from './ModifyCouponPage';

export const CouponPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifyCouponPage />} />
    <Route path='/:couponID' element={<ModifyCouponPage />} />
    <Route path='*' element={<CouponsPage />} />
  </Routes>
);
